<div *ngIf="procesos" class="container">
    
    <ul>
        <li [className]="STATUS[procesos[0].status >0 ? 3 : 0]"><span>{{ procesos[0].nombre | uppercase }}</span></li>
        <li [className]="STATUS[procesos[1].status >0 ? 3 : 0]"><span>{{ procesos[1].nombre | uppercase }}</span></li>
        <li [className]="STATUS[procesos[2].status >0 ? 3 : 0]"><span>{{ procesos[2].nombre | uppercase }}</span></li>
        <li [className]="STATUS[procesos[3] ? (procesos[3].status > 0 ? 3 : 0) :0]"><span>{{ 'comité' | uppercase }}</span></li>
    </ul>
</div>